import type { SkillRegistry } from '../battle/types';
import { CANNON } from './SparkyBot/Cannon';
import { EARTHSHAKE } from './SparkyBot/Earthshake';
import { REPAIR } from './SparkyBot/Repair';
import { CHARGE } from './SparkyBot/Charge';
import { SPARKY_BUNKER } from './SparkyBot/Bunker';
import type { SkillBundle } from './types';

// All skill bundles in the game. Adding a new skill = one new folder under
// src/skills/<Character>/<Skill>/ + one entry here.
const ALL_SKILLS: SkillBundle[] = [
  SPARKY_BUNKER,
  CANNON,
  EARTHSHAKE,
  REPAIR,
  CHARGE,
];

// Engine-facing registry: just the data, keyed by skill id. Consumed by
// resolveBattle / resolveAttackSkill / resolveBlockSkill.
export const SKILLS: SkillRegistry = new Map(
  ALL_SKILLS.map((s) => [s.engine.id, s.engine] as const),
);

// Render-facing registry: full bundle (with assets + playAttack hook) keyed by
// skill id. BattleRenderer looks up here when a skill_trigger event fires.
export const SKILL_BUNDLES: ReadonlyMap<string, SkillBundle> = new Map(
  ALL_SKILLS.map((s) => [s.engine.id, s] as const),
);

export type {
  LoadedSkillAssets,
  SkillAssetUrls,
  SkillBundle,
  SkillRenderContext,
} from './types';
